import * as React from 'react';
import { memo } from 'react';
import { Card, Divider, Row, Space, Typography } from 'antd';
import { KBEntity } from '../admin-knowledge-base.type';
import { PlusCircleOutlined } from '@ant-design/icons';
import { isTag } from '../admin-knowledge-base.utils';
import { LeftCircleOutlined } from '@ant-design/icons';
import Button from '/react4xp/mixins/ui/button/button';
import TagIcon from '/react4xp/parts/knowledge-base-common/components/tag-icon';
import {validatePrivileges} from "mixins/helpers";

interface ArticlesViewProps {
    path: string;
    goBack: () => void;
    item: KBEntity;
    children?: React.ReactNode;
    createArticleWithParents: (initialValues: {}) => void;
    roles: string[];
    privileges: string[];
}

const ArticlesView = memo(
    ({ children, goBack, path, item, createArticleWithParents, roles, privileges, }: ArticlesViewProps) => {
        return (
            <Card>
                <Row
                    justify="space-between"
                    align="middle"
                >
                    <Space size={24}>
                        <LeftCircleOutlined
                            onClick={goBack}
                            style={{ cursor: 'pointer', fontSize: '2rem' }}
                        />
                        <Space direction="vertical">
                            <span className="text-muted">{path}</span>
                            <Space>
                                {isTag(item) && (
                                    <TagIcon
                                        name={item.icon}
                                        size={32}
                                    />
                                )}
                                {item && (
                                    <Typography.Title level={5}>{item.ru.title}</Typography.Title>
                                )}
                            </Space>
                        </Space>
                    </Space>
                    {validatePrivileges(roles, privileges, 'PRIV_ARTICLE_CREATE') && (
                        <Button
                            icon={<PlusCircleOutlined />}
                            onClick={createArticleWithParents}
                            ghost
                        >
                            Добавить статью
                        </Button>
                    )}
                </Row>
                <Divider />
                {children}
            </Card>
        );
    }
);

export default ArticlesView;
